import fetch from '@/utils/fetch';
import { message } from 'antd';

const model = {
  state: {
    logFilter: {
      pageNum: 1,
      pageSize: 10,
    },
    profitFilter: {
      pageNum: 1,
      pageSize: 10,
    },
    ruleDetail: null,
  },
  reducers: {
    setState(state: any, partialState: any) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { fullReductionManage }, getState }: { dispatch: any; getState: any }) => ({
    async delRule(params) {
      const data = await fetch('/saasmerchant/web/deduction/rule/delete', {
        params,
      });
      return data;
    },
    async editRules(params) {
      const data = await fetch('/saasmerchant/web/deduction/rule/update', {
        params,
        type: 'POST',
        useJson: true,
      });
      return data;
    },
    async saveActivity(params, history) {
      const data = await fetch('/saasmerchant/web/deduction/create', {
        type: 'POST',
        useJson: true,
        params,
      });
      if (data) {
        message.success('创建成功');
        history.push('/marketing/full-reduction');
      }
    },
    async editActivity(params, history) {
      const data = await fetch('/saasmerchant/web/deduction/activity/update', {
        type: 'POST',
        useJson: true,
        params,
      });
      if (data) {
        message.success('编辑成功');
        history.push('/marketing/full-reduction');
      }
    },
    async getDeductionLogList(params) {
      const data = await fetch('/saasmerchant/web/oplog/getOpLogPage', {
        params: {
          ...params,
          type: 2,
        },
      });
      if (data) {
        fullReductionManage.setState({
          logList: data.list,
          logListTotal: data.total,
        });
      }
    },
    async getProfitList(params) {
      const data = await fetch('/saasmerchant/web/deduction/income/list', {
        params,
      });
      if (data) {
        fullReductionManage.setState({
          profitList: data.records,
          profitListTotal: data.total,
        });
      }
    },
    setLogFilter(params = {}) {
      fullReductionManage.setState({
        logFilter: { ...getState().fullReductionManage.logFilter, ...params },
      });
    },
    setProfitFilter(params = {}) {
      fullReductionManage.setState({
        profitFilter: { ...getState().fullReductionManage.profitFilter, ...params },
      });
    },
    async getExport(params) {
      const data = await fetch('/saasmerchant/web/common/export', {
        params,
        type: 'POST',
        useJson: true,
      });
      if (data) {
        message.success('导出成功');
      } else {
        message.success('导出失败');
      }
    },
    setCurrentRule(rule) {
      fullReductionManage.setState({
        ruleDetail: rule,
      });
    },
    async changeStatus(params) {
      const data = await fetch('/saasmerchant/web/deduction/change/status', {
        params,
      });
      return data;
    },
  }),
};

export default model;
